import { Component, OnInit } from "@angular/core";
import { CompanyService } from "../../../services/company.service";
import { Company } from "../../../models/company";
import { Router, ActivatedRoute } from "@angular/router";
import { Page } from "../../../models/paging/page";
import { LocationService } from "../../../services/location.service";
import { saveAs as importedSaveAs } from "file-saver";
import { ModalService } from "../../../services/modal.service";
import { ColumnService } from "../../../services/ColumnService";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: "app-locations",
  templateUrl: "./locations.component.html",
  styleUrls: ["./locations.component.css"],
})
export class LocationsComponent implements OnInit {
  modalService: ModalService;
  companies: Company[];
  client;

  filter: any = {
    location_Name: "",
    company_Id: 0,
    quick_Search: "",
  };

  availableOptions: string[] = [
    "Address 1",
    "Address 2",
    "Address 3",
    "Address 4",
    "County",
    "Post Code",
    "Telephone",
    "Fax",
    "Email",
    "Managed",
    "Expired",
    "Region",
    "History",
    "Edit",
  ];

  selectedOptions: string[] = [
    "Address 1",
    "Address 2",
    "County",
    "Telephone",
    "Fax",
    "Email",
    "Managed",
    "Expired",
    "Region",
    "History",
    "Edit",
  ];

  location_Id = 0;
  entity = "";
  showHistory: boolean = false;

  page = new Page();
  rows = Array<any>();
  init: boolean;

  constructor(
    authService: AuthService,
    private companyService: CompanyService,
    private locationService: LocationService,
    private router: Router,
    private route: ActivatedRoute,
    modalService: ModalService,
    private columnService: ColumnService
  ) {
    this.client = authService.currentUser.value;
    this.modalService = modalService;
    this.page.pageNumber = 0;
    this.page.size = 10;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.filter.company_Id = params["companyId"];
    });

    this.getcolumns();

    this.companyService.getAll(0).then((data) => {
      this.companies = data;
      this.loadTable(this.page);
      this.init = true;
    });
  }

  createCompany() {
    this.router.navigate(["administration/location_management/manage"]);
  }

  editCompany(row: any) {
    this.router.navigate(["administration/location_management/manage"], {
      queryParams: {
        location_Id: row.location_Id,
      },
    });
  }

  openAuditHistoryPopup(row) {
    this.showHistory = true;
    this.location_Id = row.location_Id;
    this.entity = "Locations";
    this.modalService.open("popup-audit-log-history");
  }

  closeAuditHistoryPopup() {
    this.showHistory = false;
    this.modalService.close("popup-audit-log-history");
  }

  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == "") {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.locationService
      .getResults(
        this.page,
        this.filter.location_Name,
        this.filter.company_Id,
        this.filter.quick_Search
      )
      .then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  generateExcel() {
    this.locationService
      .getExcel(this.page, this.filter.location_Name, this.filter.company_Id)
      .then((data) => {
        importedSaveAs(data, "Report.xlsx");
      });
  }

  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById("top");
    console.log(top);
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    console.log("triggered");
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    console.log("current user", this.client.userId);

    this.columnService
      .getColumns(this.client.userId, "locationsManagement")
      .then((data) => {
        if (data.columns != null) {
          this.selectedOptions = this.availableOptions.filter((c) => {
            return data.columns.includes(c);
          });
        }
      });
  }

  saveSelection() {
    this.columnService
      .save(this.client.userId, "locationsManagement", this.selectedOptions)
      .then((data) => {});
  }

  loadManagedCylindresInformation(row: any) {
    this.router.navigate(
      ["administration/managed-cylinder-information-management"],
      {
        queryParams: {
          locationId: row.location_Id,
          address1: row.address_1,
        },
      }
    );
  }
}
